import type { ZIndex } from './types';

const base = 10;
const above = 1;
const alwaysVisible = 999;
const productTile = base;
const rangeSlider = base;
const sortingDropdown = base + above;
const countrySelector = base + above;
const navigation = sortingDropdown + above;
const personalAide = navigation;
const searchOverlay = navigation + above;
const header = searchOverlay + above;
const overlay = header + above;
const sideDrawer = navigation + above;
const footer = base;
// The value of NavQuickLinks must be greater than baseCmsCard or else the text of the Card will overwrite the NavQuickLinks.
const navQuickLinks = above + above;
const modalContent = overlay + above;
const modalFixedFooter = modalContent + above;
const mobileMenu = modalContent + above;
const baseCmsCard = above;
// PDP sticky purchase bar: above page content, below header/overlay so
// Contact/Notify/AddToBag modals still render on top of it.
const stickyPurchaseBar = navigation;
const stickyAfterFooter = footer - above;
const navQuickLinksWithBanner = stickyAfterFooter + above;
export const zIndex: ZIndex = {
  above,
  navigation,
  sideDrawer,
  header,
  footer,
  productTile,
  rangeSlider,
  sortingDropdown,
  mobileMenu,
  countrySelector,
  overlay,
  modalContent,
  modalFixedFooter,
  searchOverlay,
  baseCmsCard,
  stickyPurchaseBar,
  navQuickLinks,
  alwaysVisible,
  personalAide,
  stickyAfterFooter,
  navQuickLinksWithBanner,
};
